import {MFAChannel} from '@eCommerce/frontend-legacy-shared-library';
import {supportPhoneNumber} from 'models/supportPhoneNumber';
import {Link, Text, View} from 'native-base';
import React, {useEffect} from 'react';
import {ROUTES} from 'routes';
import {maskEmail, maskPhoneNumber} from 'utils/utils';

import PanelContainer from 'components/PanelContainer';
import {useIsMD} from 'hooks/useIsMD';
import {useNavigateWithParams} from 'hooks/useNavigateWithParams';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

import PreferenceSelectorItem from '../PreferenceSelectorItem';
import {PreferenceSelectorWrapperProps} from '../PreferenceSelectorWrapper';

export interface PreferenceSelectorProps
  extends PreferenceSelectorWrapperProps {}

const PreferenceSelector: React.FC<PreferenceSelectorProps> = ({
  mobilePhone,
  securityEmail,
  onSendPress,
  selectedChannel,
  onSelectChannel,
  isVip,
  isLoading,
  marketingEmail,
}) => {
  const isMD = useIsMD();
  const navigate = useNavigateWithParams();
  const {trackAdobeEvent} = useTrackEvent();
  const displayMarketingEmail = marketingEmail && !securityEmail;

  const onVerifyPressed = () => {
    trackAdobeEvent({
      event: AdobeEvent.click,
      click: {name: 'mfa verify me'},
      verify: {
        sms: selectedChannel === MFAChannel.SMS ? '1' : '0',
        email: selectedChannel === MFAChannel.EMAIL ? '1' : '0',
      },
    });

    onSendPress();
  };

  const getContactInfo = () => {
    if (isVip) {
      return {
        name: 'Contact your Host',
        onPress: () => navigate(ROUTES.hostInfo),
      };
    } else {
      return {
        name: `Contact support ${supportPhoneNumber}`,
        onPress: () => (window.location.href = `tel:${supportPhoneNumber}`),
      };
    }
  };

  useEffect(() => {
    trackAdobeEvent({
      event: AdobeEvent.pageLoad,
      page: {
        name: 'mfa verification preference',
      },
    });
  }, []);

  return (
    <PanelContainer
      onPrimaryPress={onVerifyPressed}
      title="How should we contact you?"
      subTitle="Choose your preference:"
      primaryTitle="Verify me"
      isLoading={isLoading}
    >
      <View>
        {mobilePhone && (
          <PreferenceSelectorItem
            isSelected={selectedChannel === MFAChannel.SMS}
            label="Text Message"
            onSelect={() => onSelectChannel(MFAChannel.SMS)}
            value={mobilePhone && maskPhoneNumber(mobilePhone)}
          />
        )}
        <View h="12px" />
        {(securityEmail || marketingEmail) && (
          <PreferenceSelectorItem
            isSelected={selectedChannel === MFAChannel.EMAIL}
            label="Email"
            onSelect={() => onSelectChannel(MFAChannel.EMAIL)}
            value={
              displayMarketingEmail
                ? maskEmail(marketingEmail)
                : securityEmail && maskEmail(securityEmail)
            }
          />
        )}
        <View h={isMD ? '32px' : '16px'} />
        <View
          py="32px"
          bgColor="ghostWhite"
          alignItems="center"
          borderRadius="8px"
        >
          <Text
            fontFamily="body"
            fontSize="12px"
            color="tuna"
            lineHeight="24px"
          >
            Don&apos;t recognize this information?
          </Text>
          <Link
            _hover={{textDecoration: 'underline'}}
            onPress={getContactInfo()?.onPress}
          >
            <Text
              fontFamily="body"
              fontSize="12px"
              color="tuna"
              fontWeight="semibold"
              lineHeight="24px"
            >
              {getContactInfo()?.name}
            </Text>
          </Link>
        </View>
      </View>
    </PanelContainer>
  );
};

export default PreferenceSelector;
